export default __webpack_public_path__ + "empty-activity-md.9368030d.svg";